import { _ as __rest } from './_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { enforceCase, generateClasses } from '@ids/tools';
import { s as styleInject } from './style-inject.es.js';

var css_248z = ".ids-icon,\n:host.ids-icon {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: inherit;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  font: var(--ids_textStyle_icon_medium);\n  -webkit-font-feature-settings: \"liga\";\n          font-feature-settings: \"liga\";\n  -webkit-font-smoothing: antialiased;\n  font-style: normal;\n  -webkit-font-variant-ligatures: discretionary-ligatures;\n          font-variant-ligatures: discretionary-ligatures;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  letter-spacing: 0;\n  min-height: var(--ids_size_general_24x);\n  min-width: var(--ids_size_general_24x);\n  text-rendering: optimizelegibility;\n  text-transform: initial;\n}\n.ids-icon--primary,\n:host.ids-icon--primary {\n  color: var(--ids_color_action_primary_base);\n}\n.ids-icon--neutral,\n:host.ids-icon--neutral {\n  color: var(--ids_color_action_neutral_base);\n}\n.ids-icon--success,\n:host.ids-icon--success {\n  color: var(--ids_color_feedback_success);\n}\n.ids-icon--alert,\n:host.ids-icon--alert {\n  color: var(--ids_color_feedback_alert);\n}\n.ids-icon--information,\n:host.ids-icon--information {\n  color: var(--ids_color_feedback_information);\n}\n.ids-icon--error,\n:host.ids-icon--error {\n  color: var(--ids_color_feedback_error);\n}\n.ids-icon--on-brand,\n:host.ids-icon--on-brand {\n  color: var(--ids_color_contrast_onBrand_primary);\n}\n.ids-icon--small,\n:host.ids-icon--small {\n  font: var(--ids_textStyle_icon_small);\n  min-height: var(--ids_size_general_16x);\n  min-width: var(--ids_size_general_16x);\n}\n.ids-icon--large,\n:host.ids-icon--large {\n  font: var(--ids_textStyle_icon_large);\n  min-height: var(--ids_size_general_32x);\n  min-width: var(--ids_size_general_32x);\n}\n.ids-icon--xlarge,\n:host.ids-icon--xlarge {\n  font: var(--ids_textStyle_icon_xLarge);\n  min-height: var(--ids_size_general_48x);\n  min-width: var(--ids_size_general_48x);\n}";
styleInject(css_248z);

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsIcon } from '@ids/react';
 * ```
 */
const IdsIcon = _a => {
  var {
      size,
      variant,
      children,
      contrast,
      className = ''
    } = _a,
    props = __rest(_a, ["size", "variant", "children", "contrast", "className"]);
  const sizeUpperCase = enforceCase(size, 'upperCase');
  const classes = generateClasses({
    'ids-icon': true,
    'ids-icon--small': sizeUpperCase === 'S',
    'ids-icon--large': sizeUpperCase === 'L',
    'ids-icon--xlarge': sizeUpperCase === 'XL',
    'ids-icon--primary': variant === 'primary',
    'ids-icon--neutral': variant === 'neutral',
    'ids-icon--success': variant === 'success',
    'ids-icon--alert': variant === 'alert',
    'ids-icon--information': variant === 'information',
    'ids-icon--error': variant === 'error',
    'ids-icon--on-brand': contrast === 'onBrand',
    [className]: className
  });
  return jsx("span", Object.assign({
    className: classes,
    role: props['aria-label'] ? 'img' : undefined
  }, props, {
    children: jsx("span", Object.assign({
      "aria-hidden": true
    }, {
      children: children
    }))
  }));
};

export { IdsIcon as I };
//# sourceMappingURL=icon.js.map
